import { Promise } from 'core-js';

var lsCartItemName = "agxLocalCart";
function addToCart(newCartItem) {
    var lsCart = getCart();
    var oldItem = getCartItem(newCartItem.priceId, lsCart);
    if (oldItem !== null) {
        oldItem.quant = newCartItem.quant * 1 + oldItem.quant * 1;
    } else {
        lsCart.items.push(newCartItem);
    }
    updateCart(lsCart);
}

function getCart() {
    var str = localStorage.getItem(lsCartItemName);
    var lsCart = JSON.parse(str);
    if (lsCart !== null) {
        return lsCart;
    }
    return { items: [] };
}

function updateCartItem(newCartItem) {
    var lsCart = getCart();
    var oldItem = getCartItem(newCartItem.priceId, lsCart);
    if (oldItem !== null) {
        oldItem.quant = newCartItem.quant * 1;
    }
    updateCart(lsCart);
}

function updateCart(lsCart) {
    localStorage.setItem(lsCartItemName, JSON.stringify(lsCart));
}

function getCartItem(priceId, lsCart) {
    var items = lsCart.items;
    if (items.length === 0) return null;
    var matches = items.filter(t => t.priceId === priceId);
    if (matches.length > 0) {
        return matches[0];
    }
    return null;
}

function removeCartItem(priceId) {
    var lsCart = getCart();
    var oldItem = getCartItem(priceId, lsCart);
    if (oldItem !== null) {
        var index = lsCart.items.indexOf(oldItem);
        lsCart.items.splice(index,1);
    }
    updateCart(lsCart);
}

function clearCart() {
    updateCart({ items: [] });
}

var api = {
    addToCartPrms: function (newItem) {
        addToCart(newItem);
        return Promise.resolve({ ok: true });
    },
    getCart: getCart,
    removeItem: removeCartItem,
    updateCartItem: updateCartItem,
    clearCart: clearCart
}


//test case//
/*
var sampleItems = [{ priceId: 61885, quant: "1" }, { priceId: 61882, quant: "1" }];
for (var i = 0; i < sampleItems.length; i++) {
    var item = sampleItems[i];
    api.addToCartPrms(item);
}
api.getCart();
api.removeItem(sampleItems[1].priceId);
api.getCart();
*/
//end test case//

export default {
    api: api
}